import { createThemeAppConfig } from "@package/util/utils/themeAppConfig";

export const THEME_APP_CONFIG = createThemeAppConfig({
  appName: "agavian-ent",
  themeId: 11,
  themeVariant: "enterprise",
  displayName: "Enterprise",
  theme: {
    forceEcommerceEnabled: true,
    primaryColor: "#19497A",
    secondaryColor: "#E7F1F8",
    muiSecondaryColor: "#E7F1F8",
    backgroundColor: "#F5F9FC",
    textColor: "#0F2D4A",
    buttonColor: "#19497A",
    buttonHoverColor: "#0F315A",
    buttonTextColor: "#ffffff",
    accentColor: "#5FA8D3",
    searchBorder: "rgba(25, 73, 122, 0.16)",
    navbar: {
      backgroundColor: "#ffffff",
      backgroundImage: "none",
      textColor: "#19497A",
      iconColor: "#19497A",
      logoColor: "#19497A",
      mobileMenuBackgroundColor: "#ffffff",
      borderBottom: "1px solid rgba(25, 73, 122, 0.14)",
      hoverColor: "#0F315A",
      useFilledUserIcon: false,
      otpModal: {
        modalBg: "#ffffff",
        heading: "#0F2D4A",
        text: "#244764",
        subtext: "#496B86",
        border: "rgba(25, 73, 122, 0.18)",
        inputBg: "#ffffff",
        inputText: "#101828",
        primaryBtnBg: "#19497A",
        primaryBtnText: "#ffffff",
        secondaryBtnBg: "#E7F1F8",
        secondaryBtnText: "#0F2D4A",
        divider: "rgba(25, 73, 122, 0.1)",
      },
    },
    cartPopup: {
      primaryColor: "#19497A",
      primaryHoverColor: "#0F315A",
      textColor: "#0F2D4A",
      mutedTextColor: "#496B86",
      background: "#ffffff",
      border: "rgba(25, 73, 122, 0.14)",
      softBackground: "#F5F9FC",
      secondaryActionBackground: "#E7F1F8",
      secondaryActionText: "#0F2D4A",
    },
    singleProductActionBar: {
      addToCartBackground: "#187f9e",
      addToCartHoverBackground: "#126a84",
      addToCartBorderColor: "#187f9e",
      addToCartTextColor: "#ffffff",
      chipTextColor: "#187f9e",
      highlightTextColor: "#187f9e",
    },
    singleProductBenefits: {
      textColor: "#187f9e",
      chipTextColor: "#187f9e",
      cardTitleColor: "#187f9e",
    },
    singleProductOrdering: {
      headingColor: "#187f9e",
      stepTextColor: "#187f9e",
      cardTitleColor: "#187f9e",
    },
    singleProductCustomerLove: {
      headingColor: "#187f9e",
    },
    footer: {
      mainBackgroundColor: "#0F315A",
      mainBackgroundImage: "none",
      mainTextColor: "#ffffff",
      brandTextColor: "#ffffff",
    },
    shippingPromo: {
      background: "linear-gradient(90deg, #19497A 0%, #0F315A 50%, #19497A 100%)",
      color: "#FFFFFF",
      accent: "#BFD9EA",
      border: "rgba(25, 73, 122, 0.15)",
      shadow: "0 10px 20px rgba(25, 73, 122, 0.18)",
      letterSpacing: "0.08em",
      minHeight: "42px",
      padding: "0.65rem 1rem",
      gap: "0.85rem",
      dotSize: "6px",
      fontSize: "0.95rem",
      fontWeight: 700,
      textTransform: "uppercase",
      mobileFontSize: "0.82rem",
      mobileTextLetterSpacing: "0.05em",
    },
    customizedProducts: {
      sectionBackgroundColor: "#ffffff",
      titleColor: "#19497A",
      subtitleColor: "#496B86",
      cardTitleColor: "#0F2D4A",
      imageBackgroundColor: "#f9f9f9",
    },
    productsShowcase: {
      sectionBackgroundColor: "#F5F9FC",
      sectionPadding: "4rem 1rem",
      titleColor: "#19497A",
      subtitleColor: "#496B86",
      subtitleMarginBottom: "4rem",
      subtitleSpacing: "0 auto 4rem auto",
      categoryTitleColor: "#19497A",
      imageContainerBackgroundColor: "transparent",
      ratingBackgroundColor: "#f9f9f9",
      hoverShadowColor: "rgba(25, 73, 122, 0.12)",
      featuredCardTitleColor: "#0F2D4A",
    },
    testimonials: {
      sectionBackgroundColor: "#F5F9FC",
      titleColor: "#19497A",
      subtitleColor: "#496B86",
    },
    aboutPage: {
      pageBg: "#FFFFFF",
      sectionAlt: "#F9F9F9",
      text: "#0F2D4A",
      muted: "rgba(15, 45, 74, 0.72)",
      accent: "#19497A",
      cardBg: "rgba(255,255,255,0.95)",
      border: "rgba(25, 73, 122, 0.10)",
      shadow: "0 20px 60px rgba(25, 73, 122, 0.10)",
      heroBg: "linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(245,249,252,0.98) 58%, rgba(25,73,122,0.08) 100%)",
    },
  },
  surfaces: {
    pageBackground: "linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(245,249,252,0.96) 100%)",
    cardBackground: "rgba(255,255,255,0.95)",
    cardBorder: "1px solid rgba(25, 73, 122, 0.10)",
    cardShadow: "0 20px 60px rgba(25, 73, 122, 0.10)",
  },
  bodyColor: "rgba(15, 45, 74, 0.78)",
});

export const APP_THEME = THEME_APP_CONFIG.theme;
export const APP_MUI_THEME = THEME_APP_CONFIG.muiTheme;
